import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Api = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
    
  useEffect(() => {
    loadLanguageFile("Api", "terms/api_body_lang");
  }, [language]);
  const LANGUAGE = componentLanguageData.Api || { Main: {} };
  return (
    <div className="container py-5 text-start" style={{ lineHeight: "1.8em" }}>
      <h2 className="mb-4">{LANGUAGE.Main.Content1}</h2>

      <h4>{LANGUAGE.Main.Content2}</h4>
      <p>
      {LANGUAGE.Main.Content3}<strong>{LANGUAGE.Main.Content4}</strong>{LANGUAGE.Main.Content5}
      </p>
      <p>
      {LANGUAGE.Main.Content6}
      </p>

      <h4>{LANGUAGE.Main.Content7}</h4>
      <ul>
        <li>
          <strong>{LANGUAGE.Main.Content8}</strong>  {LANGUAGE.Main.Content9}
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content10}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content11}</li>
            <li>{LANGUAGE.Main.Content12}</li>
            <li>{LANGUAGE.Main.Content13}</li>
          </ul>
        </li>
        <li>
          <strong>{LANGUAGE.Main.Content14}</strong>
          <ul>
            <li>{LANGUAGE.Main.Content15}</li>
            <li>{LANGUAGE.Main.Content16}</li>
            <li>{LANGUAGE.Main.Content17}</li>
          </ul>
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content18}</h4>
      <ul>
        <li>{LANGUAGE.Main.Content19}</li>
        <li>{LANGUAGE.Main.Content20}</li>
        <li>{LANGUAGE.Main.Content21}</li>
      </ul>

      <h4>{LANGUAGE.Main.Content22}</h4>
      <ul>
        <li>{LANGUAGE.Main.Content23}</li>
        <li>{LANGUAGE.Main.Content24}</li>
        <li>{LANGUAGE.Main.Content25}</li>
      </ul>

      <h4>{LANGUAGE.Main.Content26}</h4>
      <ul>
        <li>{LANGUAGE.Main.Content27}</li>
        <li>{LANGUAGE.Main.Content28}</li>
        <li>{LANGUAGE.Main.Content29}</li>
      </ul>

      <h4>{LANGUAGE.Main.Content30}</h4>
      <ul>
        <li>
        {LANGUAGE.Main.Content31}
        </li>
        <li>
        {LANGUAGE.Main.Content32}
        </li>
        <li>
        {LANGUAGE.Main.Content33}
        </li>
      </ul>

      <h4>{LANGUAGE.Main.Content34}</h4>
      <ul>
        <li>{LANGUAGE.Main.Content35}</li>
        <li>{LANGUAGE.Main.Content36}</li>
      </ul>

      <h4>{LANGUAGE.Main.Content37}</h4>
      <ul>
        <li>{LANGUAGE.Main.Content38}</li>
        <li>{LANGUAGE.Main.Content39}</li>
      </ul>

      <h4>{LANGUAGE.Main.Content40}</h4>
      <ul>
        <li>{LANGUAGE.Main.Content41}</li>
        <li>{LANGUAGE.Main.Content42}</li>
        <li>{LANGUAGE.Main.Content43}</li>
      </ul>

      <hr className="my-4" />

      <h5>{LANGUAGE.Main.Content44}</h5>
      <p>
      {LANGUAGE.Main.Content45}<br />
        <strong>{LANGUAGE.Main.Content46}</strong> {LANGUAGE.Main.Content47}<br />
        <strong>{LANGUAGE.Main.Content48}</strong> <a href={`mailto:${LANGUAGE?.Main?.Content49}`}>{LANGUAGE.Main.Content49}</a><br />
        <strong>{LANGUAGE.Main.Content50}</strong> <a href={LANGUAGE?.Main?.Content51} target="_blank" rel="noopener noreferrer">{LANGUAGE.Main.Content51}</a>
      </p>
    </div>
  );
};

export default Api;
